import ar from '../translations/ar.json'
import es from '../translations/es.json'
import el from '../translations/el.json'
import en from '../translations/en.json'
import da from '../translations/da.json'
import de from '../translations/de.json'
import pt from '../translations/pt.json'
import ja from '../translations/ja.json'
import fr from '../translations/fr.json'
import it from '../translations/it.json'
import nl from '../translations/nl.json'
import th from '../translations/th.json'
import ru from '../translations/ru.json'
import ro from '../translations/ro.json'
import vi from '../translations/vi.json'
import zh from '../translations/zh.json'
import sv from '../translations/sv.json'
import tr from '../translations/tr.json'
import pl from '../translations/pl.json'
import ko from '../translations/ko.json'

export default {
    'ar': ar.ar_SA,
    'es': es.es_ES,
    'el': el.el_GR,
    'en_US': en.en_US,
    'da': da.da_DK,
    'de': de.de_DE,
    'pt': pt.pt_BR,
    'ja': ja.ja_JP,
    'fr': fr.fr_FR,
    'it': it.it_IT,
    'sv': sv.sv_SE,
    'th': th.th_TH,
    'tr': tr.tr_TR,
    'vi': vi.vi_VN,
    'ru': ru.ru_RU,
    'ro': ro.ro_RO,
    'nl': nl.nl_NL,
    'zh': zh.zh_CN,
    'ko': ko.ko_KR,
    'pl': pl.pl_PL
}